var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNetwork1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.14844 12.3134C8.00038 9.67953 11.8127 8.07031 16.001 8.07031C20.1892 8.07031 24.0016 9.67953 26.8535 12.3134M8.53986 15.9874C10.5006 14.1767 13.1216 13.0703 16.001 13.0703C18.8804 13.0703 21.5014 14.1767 23.4621 15.9874M11.9313 19.6615C13.0008 18.6738 14.4304 18.0703 16.001 18.0703C17.5716 18.0703 19.0012 18.6738 20.0707 19.6615",
    stroke: "#383B41",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2278 23.4264C17.2278 24.1042 16.6784 24.6536 16.0006 24.6536C15.3229 24.6536 14.7734 24.1042 14.7734 23.4264C14.7734 22.7487 15.3229 22.1992 16.0006 22.1992C16.6784 22.1992 17.2278 22.7487 17.2278 23.4264Z",
    fill: "#383B41"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetwork1);
export default __webpack_public_path__ + "static/media/network-1.f062140fd9079619c6d93f97a2efa6f7.svg";
export { ForwardRef as ReactComponent };